import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/data/site";

const chapters = [
  {
    n: "01",
    title: "Una nuova storia di gusto",
    body: "SAPORÉ nasce con un obiettivo preciso: offrire una cucina d'asporto buona, accessibile e preparata con la stessa attenzione che si dedica ai piatti di casa. Ogni giorno lavoriamo per proporre una scelta varia di primi, secondi, contorni, focacce e specialità della tradizione. Dietro ogni preparazione ci sono passione, organizzazione e rispetto per il cliente.",
  },
  {
    n: "02",
    title: "La nostra filosofia",
    body: "Crediamo in una cucina semplice ma ricca di sapore, preparata con attenzione, legata alle tradizioni del territorio, adatta alla vita quotidiana e capace di unire comodità e qualità. Da SAPORÉ non trovi soltanto qualcosa di pronto da mangiare: trovi il piacere di un piatto pensato per i tuoi momenti più importanti.",
  },
  {
    n: "03",
    title: "La cucina di Puce Maria",
    body: "La guida e l'esperienza di Puce Maria rappresentano il cuore del progetto: una cucina autentica, fatta di attenzione, passione e sapori familiari, capace di far sentire ogni cliente accolto e di trasformare anche un semplice pranzo d'asporto in un momento piacevole.",
  },
];

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <Overline>Chi siamo</Overline>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-none tracking-tight text-charred">
                Il gusto di<br /><span className="italic text-terracotta">sentirsi a casa</span>
              </h2>
              <p className="mt-6 text-charred/70 leading-relaxed">
                Da SAPORÉ la cucina nasce dalla passione per le ricette semplici, genuine e ricche di sapore. Ogni giorno prepariamo piatti caldi e specialità d'asporto con attenzione alla qualità degli ingredienti, alla freschezza e alla varietà delle proposte.
              </p>
            </Reveal>

            <div className="mt-14 space-y-12">
              {chapters.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.1} className="relative pl-20 md:pl-24">
                  <span className="absolute left-0 top-0 font-serif font-light text-5xl md:text-6xl text-terracotta/30 leading-none">{c.n}</span>
                  <h3 className="font-serif text-2xl md:text-3xl text-charred">{c.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-charred/70 leading-relaxed">{c.body}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7 md:sticky md:top-28">
            <Reveal delay={0.15}>
              <div className="noise-frame overflow-hidden rounded-[4px] aspect-[4/5] group">
                <img
                  src={IMAGES.story}
                  alt="Sfoglia di pasta preparata a mano"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <p className="mt-4 font-serif italic text-lg text-charred/60">"Piatti preparati con cura, proprio come a casa."</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
